module.exports = __webpack_public_path__ + "img/hest1.980203cc.jpg";